export const CountryId = {
  PERU: 'PE',
  BRAZIL: 'BR',
  CHILE: 'CL',
  COLOMBIA: 'CO',
  ARGENTINA: 'AR',
  MEXICO: 'MX',
  MALAYSIA: 'MY',
  ECUADOR: 'EC',
}

export const validCountryIds = [
  CountryId.PERU,
  CountryId.BRAZIL,
  CountryId.CHILE,
  CountryId.COLOMBIA,
  CountryId.ARGENTINA,
  CountryId.MEXICO,
  CountryId.MALAYSIA,
  CountryId.ECUADOR,
]
